"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { CoreAccessRule } from "@/framework/access-control-lists";
import API from "@ym-framework/api-utils";
import { AccountSessionStorage } from "@/service/account-session";
import axios from "axios";
import { MAIN_WEBSOCKET, WEB_HTML, MESSAGE_SERVICE } from "@/configuration/websocketskey";
import { ModelBuilderUtil } from "@ym-framework/model";
let Kvurl = "https://api.kuajingvs.com";
let SessionUrl = "https://gateway.kuajingvs.com/pro";
if (process.env.YM_TEST === "true") {
  Kvurl = "https://test-api.kuajingvs.com";
  SessionUrl = "https://gateway.kuajingvs.com/kjvs/pro-dev";
}
export class VeiwOptions {
  constructor(optionsHandle) {
    this._optionsHandle = optionsHandle;
  }
  options(to, from, next) {
    return __async(this, null, function* () {
      try {
        const _response = yield this._optionsHandle(to, from, next);
        return true;
      } catch (error) {
        return false;
      }
    });
  }
}
export class AppAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      next();
    });
  }
}
export class GuestAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      if (chrome.virtualBrowserManager === void 0 && chrome.clientServer === void 0 && chrome.application === void 0) {
        location.href = "https://www.kuajingvs.com";
      }
      next();
    });
  }
}
export class ToManagerAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      var _a;
      console.dir("ToManagerAccess ===========================");
      try {
        if (chrome.virtualBrowserManager === void 0 && chrome.clientServer === void 0) {
          location.href = "https://www.kuajingvs.com";
        }
        let token = yield API.get(`api://base.local/storages/preference/token`);
        const _token = token.data.value.token;
        let session_response = yield axios.get(`${SessionUrl}/v1/account/session`, {
          headers: {
            "Authorization": _token,
            "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
          }
        });
        const session = ModelBuilderUtil.builder(session_response.data);
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        AccountSessionStorage.setSession(session);
        let accountType = session.type || "";
        if (accountType === "account") {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = "https://pre.kuajingvs.com/team";
          } else {
            next("/team");
          }
        } else if (accountType === "user") {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = "https://pre.kuajingvs.com/account_child";
          } else {
            next("/account_child");
          }
        } else {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = "https://pre.kuajingvs.com/";
          } else {
            next("/");
          }
        }
      } catch (error) {
        console.log(error);
        console.dir("ToManagerAccess  error ===========================");
        yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.post(`api://base.local/websockets/${MESSAGE_SERVICE}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
        yield API.delete(`api://base.local/storages/session/session`);
        yield API.delete(`api://base.local/storages/preference/token`);
        localStorage.removeItem("gift_show");
        let _html = `${WEB_HTML}/home`;
        window.open(_html, "_self");
      }
    });
  }
}
export class ToSecurityAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      var _a;
      console.dir("ToSecurityAccess ===========================");
      try {
        if (chrome.virtualBrowserManager === void 0 && chrome.clientServer === void 0) {
          location.href = "https://www.kuajingvs.com";
        }
        let token = yield API.get(`api://base.local/storages/preference/token`);
        const _token = token.data.value.token;
        let session_response = yield axios.get(`${SessionUrl}/v1/account/session`, {
          headers: {
            "Authorization": _token,
            "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
          }
        });
        const session = ModelBuilderUtil.builder(session_response.data);
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        AccountSessionStorage.setSession(session);
        let accountType = session.type || "";
        let permissions = session.permissions;
        if (accountType === "account" || accountType === "user" && permissions.any("ACCESS_CONTROL_SETTING", "ACCESS_CONTROL_APPROVAL")) {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = "https://pre.kuajingvs.com/security";
          } else {
            next("/security");
          }
        } else if ((accountType === "account" || accountType === "user" && permissions.any("IN_PROCESS_MONITORING_SETTING", "IN_PROCESS_MONITORING_APPROVAL")) && session.marks.is("SHOW_MONITOR_MANAGER")) {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = "https://pre.kuajingvs.com/more_safe_manager";
          } else {
            next("/more_safe_manager");
          }
        } else {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = "https://pre.kuajingvs.com/";
          } else {
            next("/");
          }
        }
      } catch (error) {
        console.log(error);
        console.dir("ToManagerAccess  error ===========================");
        yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.post(`api://base.local/websockets/${MESSAGE_SERVICE}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
        yield API.delete(`api://base.local/storages/session/session`);
        yield API.delete(`api://base.local/storages/preference/token`);
        localStorage.removeItem("gift_show");
        let _html = `${WEB_HTML}/home`;
        window.open(_html, "_self");
      }
    });
  }
}
export class UserAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      var _a;
      console.dir("UserAccess ===========================");
      try {
        if (chrome.virtualBrowserManager === void 0 && chrome.clientServer === void 0) {
          location.href = "https://www.kuajingvs.com";
        }
        let token = yield API.get(`api://base.local/storages/preference/token`);
        const _token = token.data.value.token;
        let session_response = yield axios.get(`${SessionUrl}/v1/account/session`, {
          headers: {
            "Authorization": _token,
            "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
          }
        });
        const session = ModelBuilderUtil.builder(session_response.data);
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        AccountSessionStorage.setSession(session);
        let accountType = session.type || "";
        if (accountType === "" || accountType === "account") {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = "https://pre.kuajingvs.com/";
          } else {
            next("/");
          }
        } else {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = "https://pre.kuajingvs.com/account_child";
          } else {
            next();
          }
        }
      } catch (error) {
        console.log(error);
        console.dir("UserAccess  error ===========================");
        yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.post(`api://base.local/websockets/${MESSAGE_SERVICE}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
        yield API.delete(`api://base.local/storages/session/session`);
        yield API.delete(`api://base.local/storages/preference/token`);
        localStorage.removeItem("gift_show");
        let _html = `${WEB_HTML}/home`;
        window.open(_html, "_self");
      }
    });
  }
}
export class MainPageAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      var _a;
      console.dir("MainPageAccess ===========================");
      try {
        if (chrome.virtualBrowserManager === void 0 && chrome.clientServer === void 0 && chrome.application === void 0) {
          location.href = "https://www.kuajingvs.com";
        }
        let token = yield API.get(`api://base.local/storages/preference/token`);
        const _token = token.data.value.token;
        let session_response = yield axios.get(`${SessionUrl}/v1/account/session`, {
          headers: {
            "Authorization": _token,
            "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
          }
        });
        const session = ModelBuilderUtil.builder(session_response.data);
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        AccountSessionStorage.setSession(session);
        if (session.type === "user" && (session.role_name !== "\u7BA1\u7406\u5458" && session.role_name !== "administrators" && session.role_name !== "Administrador") && session.permissions.is("VD_LIST_MODE_INVISIBLE")) {
          localStorage.setItem("page_mode", "shop");
        }
        if (localStorage.getItem("page_mode") !== null && localStorage.getItem("page_mode") !== "") {
          if (localStorage.getItem("page_mode") === "shop") {
            if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
              location.href = "https://pre.kuajingvs.com/virtual-shop";
            } else {
              next("/virtual-shop");
            }
          } else {
            if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
              location.href = `https://pre.kuajingvs.com${to.path}`;
            } else {
              next();
            }
          }
        } else {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = `https://pre.kuajingvs.com${to.path}`;
          } else {
            next();
          }
        }
      } catch (error) {
        console.log(error);
        yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.post(`api://base.local/websockets/${MESSAGE_SERVICE}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
        yield API.delete(`api://base.local/storages/session/session`);
        yield API.delete(`api://base.local/storages/preference/token`);
        localStorage.removeItem("gift_show");
        let _html = `${WEB_HTML}/home`;
        window.open(_html, "_self");
      }
    });
  }
}
export class AccountAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      var _a;
      console.dir("AccountAccess ===========================");
      try {
        if (chrome.virtualBrowserManager === void 0 && chrome.clientServer === void 0) {
          location.href = "https://www.kuajingvs.com";
        }
        let token = yield API.get(`api://base.local/storages/preference/token`);
        const _token = token.data.value.token;
        let session_response = yield axios.get(`${SessionUrl}/v1/account/session`, {
          headers: {
            "Authorization": _token,
            "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
          }
        });
        const session = ModelBuilderUtil.builder(session_response.data);
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        AccountSessionStorage.setSession(session);
        if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
          location.href = `https://pre.kuajingvs.com${to.path}`;
        } else {
          next();
        }
      } catch (error) {
        console.log(error);
        yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.post(`api://base.local/websockets/${MESSAGE_SERVICE}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
        yield API.delete(`api://base.local/storages/session/session`);
        yield API.delete(`api://base.local/storages/preference/token`);
        localStorage.removeItem("gift_show");
        let _html = `${WEB_HTML}/home`;
        window.open(_html, "_self");
      }
    });
  }
}
export class MessageAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      var _a;
      console.dir("MessageAccess ===========================");
      try {
        if (chrome.virtualBrowserManager === void 0 && chrome.clientServer === void 0) {
          location.href = "https://www.kuajingvs.com";
        }
        let token = yield API.get(`api://base.local/storages/preference/token`);
        const _token = token.data.value.token;
        let session_response = yield axios.get(`${SessionUrl}/v1/account/session`, {
          headers: {
            "Authorization": _token,
            "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
          }
        });
        const session = ModelBuilderUtil.builder(session_response.data);
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        AccountSessionStorage.setSession(session);
        if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
          location.href = `https://pre.kuajingvs.com${to.path}`;
        } else {
          next();
        }
      } catch (error) {
        console.dir("MessageAccess  error ===========================");
        yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.post(`api://base.local/websockets/${MESSAGE_SERVICE}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
        yield API.delete(`api://base.local/storages/session/session`);
        yield API.delete(`api://base.local/storages/preference/token`);
        localStorage.removeItem("gift_show");
        next("/auth_login");
      }
    });
  }
}
export class AuthAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      var _a;
      console.dir("AuthAccess ===========================");
      try {
        if (chrome.virtualBrowserManager === void 0 && chrome.clientServer === void 0) {
          location.href = "https://www.kuajingvs.com";
        }
        let token = yield API.get(`api://base.local/storages/preference/token`);
        const _token = token.data.value.token;
        let session_response = yield axios.get(`${SessionUrl}/v1/account/session`, {
          headers: {
            "Authorization": _token,
            "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
          }
        });
        const session = ModelBuilderUtil.builder(session_response.data);
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        AccountSessionStorage.setSession(session);
        let accountType = session.type || "";
        let permissions = session.permissions;
        if (accountType === "" || accountType === "user" && !permissions.any("SHOW_ALL_MENUS", "TEAM_LOGIN_SETTING", "TEAM_LOGIN_APPROVAL", "ACCESS_CONTROL_SETTING", "ACCESS_CONTROL_APPROVAL", "IN_PROCESS_MONITORING_SETTING", "IN_PROCESS_MONITORING_APPROVAL")) {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = "https://pre.kuajingvs.com/";
          } else {
            next("/");
          }
        } else {
          if (session.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
            location.href = `https://pre.kuajingvs.com${to.path}`;
          } else {
            next();
          }
        }
      } catch (error) {
        console.dir("AuthAccess  error ===========================");
        yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.post(`api://base.local/websockets/${MESSAGE_SERVICE}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
        yield API.delete(`api://base.local/storages/session/session`);
        yield API.delete(`api://base.local/storages/preference/token`);
        localStorage.removeItem("gift_show");
        let _html = `${WEB_HTML}/home`;
        window.open(_html, "_self");
      }
    });
  }
}
export class LogAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      var _a;
      console.dir("LogAccess ===========================");
      try {
        if (chrome.virtualBrowserManager === void 0 && chrome.clientServer === void 0) {
          location.href = "https://www.kuajingvs.com";
        }
        let token = yield API.get(`api://base.local/storages/preference/token`);
        const _token = token.data.value.token;
        let session_response = yield axios.get(`${SessionUrl}/v1/account/session`, {
          headers: {
            "Authorization": _token,
            "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
          }
        });
        const session = ModelBuilderUtil.builder(session_response.data);
        yield API.put(`api://base.local/storages/session/session`, {
          session
        });
        AccountSessionStorage.setSession(session);
        let accountType = session.type || "";
        let permissions = session.permissions;
        if (accountType === "" || accountType === "user" && !permissions.any("SHOW_ALL_MENUS", "VIEW_LOGIN_LOG", "VIEW_MANAGEMENT_LOG", "VIEW_VISIT_LOG", "VIEW_RISK_LOG", "VIEW_ACCOUNT_LOGIN_LOG", "VIEW_TEAM_LOG", "EXPORT_VISIT_LOG", "EXPORT_ACCOUNT_LOGIN_LOG", "VIEW_TRAFFIC_LOG")) {
          next("/");
        } else {
          next();
        }
      } catch (error) {
        console.dir("AuthAccess  error ===========================");
        yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.post(`api://base.local/websockets/${MESSAGE_SERVICE}`, {
          "model": "pageEvent.logout.success",
          "value": {
            "message": "logout.success"
          }
        });
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
        yield API.delete(`api://base.local/storages/session/session`);
        yield API.delete(`api://base.local/storages/preference/token`);
        localStorage.removeItem("gift_show");
        let _html = `${WEB_HTML}/home`;
        window.open(_html, "_self");
      }
    });
  }
}
export class LogoutAccess extends CoreAccessRule {
  next(to, from, next) {
    return __async(this, null, function* () {
      if (chrome.virtualBrowserManager === void 0 && chrome.clientServer === void 0) {
        next("https://www.kuajingvs.com");
      }
      console.dir("LogoutAccess ===========================");
      yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
        "model": "pageEvent.logout.success",
        "value": {
          "message": "logout.success"
        }
      });
      yield API.post(`api://base.local/websockets/${MESSAGE_SERVICE}`, {
        "model": "pageEvent.logout.success",
        "value": {
          "message": "logout.success"
        }
      });
      yield API.delete(`api://base.local/v2/browsers`);
      yield API.delete(`api://base.local/v2/dynamic-browsers`);
      yield API.delete(`api://base.local/processes`);
      yield API.delete(`api://base.local/storages/preference/token`);
      yield API.delete(`api://base.local/storages/session/session`);
      localStorage.removeItem("gift_show");
      let _html = `${WEB_HTML}/home`;
      window.open(_html, "_self");
    });
  }
}
